/* eslint-disable camelcase */
import dayjs from "dayjs";

import { MeteringByAccountData, MeteringByDetectorData } from "components/account/MeteringInfo";

// Array of months
export const months = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

// This function takes in the metering data and parses it into a format that can be used by the barchart
// It formats the interval_start to the correct format based on the interval (day or month)
// It also performs the image_queries - escalations operation and sets it to zero if it's negative
// (this is to avoid negative values in the barchart)
export function parseMeteringToBarchartInfo(interval: string, meteringData: MeteringByAccountData[] = []) {
  const parsedBarchartData: MeteringByAccountData[] = [];

  let formatString = "MM/DD"; // Initialize with the day format

  if (interval === "month") {
    formatString = "MMMM"; // Use the month format
  }

  meteringData.forEach((item) => {
    const { interval_start, active_detectors, image_queries, escalations, userLabelersAnswers } = item;
    // Perform the image_queries - escalations operation and set it to zero if it's negative
    const updatedImageQueries = Math.max(image_queries - escalations, 0);

    // Push the modified object to parsedBarchartData
    parsedBarchartData.push({
      interval_start: dayjs(interval_start).format(formatString),
      active_detectors,
      image_queries,
      escalations,
      userLabelersAnswers,
      graphImageQueries: updatedImageQueries,
    });
  });

  return parsedBarchartData;
}

// This function takes the detectors data and sums the total number of
// active detectors, total queries and total escalations
// It returns an object with the sum of each of these values
export function sumDetectorInformation(detectorsMeteringData: MeteringByDetectorData[] = []) {
  const sum = {
    activeDetectors: 0,
    totalQueries: 0,
    totalEscalations: 0,
  };

  detectorsMeteringData.forEach((detector) => {
    sum.activeDetectors += 1;
    sum.totalQueries += detector.image_queries;
    sum.totalEscalations += detector.escalations;
  });

  return sum;
}

// This fucntion validates that the account account metrics are a valid format
export const isAccountMetricsValid = (accountMetrics: any): boolean =>
  Array.isArray(accountMetrics) &&
  accountMetrics.length > 0 &&
  accountMetrics[0] &&
  typeof accountMetrics[0].active_detectors === "number" &&
  typeof accountMetrics[0].image_queries === "number" &&
  typeof accountMetrics[0].escalations === "number" &&
  typeof accountMetrics[0].interval_start === "string";

// This fucntion validates that the detectors metrics are a valid format
export const isDetectorsMetricsValid = (detectorsMetrics: any): boolean =>
  Array.isArray(detectorsMetrics) &&
  detectorsMetrics.every(
    (detectorMetric) =>
      detectorMetric &&
      typeof detectorMetric.escalations === "number" &&
      typeof detectorMetric.image_queries === "number" &&
      typeof detectorMetric.interval_start === "string" &&
      typeof detectorMetric.detector_name === "string" &&
      typeof detectorMetric.detector_id === "string"
  );
